import { DetailsContainer } from "./DetailStyles";
import StatusIndicator from "./StatusIndicator";
import DetailItem from "./DetailItem";

const TransactionDetails = ({ transaction }: { transaction: any }) => {
    const detailItems = [
        { label: "مبلغ تراکنش (ریال)", value: `${(transaction.amount || 0).toLocaleString('fa-IR')} ریال` },
        { label: "قیمت لحظه ای طلا", value: `${(transaction.req_price_gold || 0).toLocaleString('fa-IR')} ریال` },
        { label: "وزن طلا (گرم)", value: `${transaction.req_gold_weight || '-'} گرم` },
        { label: "نام نماینده", value: transaction.shop || '-' },
        { label: "تاریخ و ساعت تراکنش", value: transaction.created_at ? new Date(transaction.created_at * 1000).toLocaleDateString('fa-IR') : '-' },
        { label: "شناسه دستگاه (IMEI)", value: transaction.imei ? transaction.imei : '-' },
        { label: "کد تراکنش", value: transaction.transaction_code || '-' },
        { label: "کد رهگیری", value: transaction.authority || '-' },
        { label: "کد پرداخت شتابی", value: transaction.payment_internal_credit_id || '-' },
        { label: "کد تراکنش", value: transaction.transaction_code || '-' },
        { label: "کد هش", value: transaction.hash || '-' },
    ];

    return (
        <DetailsContainer>
            <StatusIndicator status={transaction.status} />
            {detailItems.map((item, index) => (
                <DetailItem key={index} label={item.label} value={item.value} />
            ))}
        </DetailsContainer>
    );
};

export default TransactionDetails;